// extracted by mini-css-extract-plugin
module.exports = {"bytes":"Bytes_bytes__SX2x1"};